import axios from "axios";

const WEB3FORMS_KEY = "7146e56a-6101-43bb-8c6b-54023812090a";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// The deployed Cloudflare site is frontend-only. Keep the existing API client
// for compatibility, but route legacy studio/project inquiries through the
// same Web3Forms inbox used by the public contact and quote forms.
api.interceptors.request.use((config) => {
  if (config.url === "/inquiries" && config.method?.toLowerCase() === "post" && config.data?.type === "studio") {
    const data = config.data;
    config.baseURL = "";
    config.url = "https://api.web3forms.com/submit";
    config.withCredentials = false;
    config.headers = { ...config.headers, "Content-Type": "application/json", Accept: "application/json" };
    config.data = {
      access_key: WEB3FORMS_KEY,
      subject: "Neue Projektanfrage – PILATES ON.",
      from_name: "PILATES ON. Website",
      anfrage_typ: "Projektanfrage / Studio",
      vorname: data.first_name,
      nachname: data.last_name,
      unternehmen: data.company || "–",
      email: data.email,
      telefon: data.phone || "–",
      ort: data.location || "–",
      produkte: Array.isArray(data.items) && data.items.length ? data.items.join(", ") : "–",
      edition: data.finish || "–",
      stueckzahl: data.quantity ?? "–",
      eroeffnung: data.opening_date || "–",
      nachricht: data.message || "–",
      sprache: data.language || "–",
    };
  }
  return config;
});
